export default __webpack_public_path__ + "static/image8-139d1a2aec17f9efd47aed94bc06ed42.gif";